import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@nokowazzi/types';

export type BrowserSupabase = SupabaseClient<Database>;

export interface CreateBrowserClientOptions {
  url: string;
  anonKey: string;
}

/**
 * 브라우저(유저 앱)용 Supabase 클라이언트.
 * 용도: Auth 세션, RLS 읽기, Realtime private 채널 구독, 알림 읽음처리.
 * 돈·상태머신·번역이 걸린 쓰기는 전부 API(Worker) 경유 — 직접 insert/update 금지.
 */
export function createBrowserClient({ url, anonKey }: CreateBrowserClientOptions): BrowserSupabase {
  return createClient<Database>(url, anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
    realtime: {
      params: { eventsPerSecond: 10 },
    },
  });
}

/** private 채널 구독 헬퍼 — 채널명 규약: chat:{roomId} / user:{userId} */
export function chatChannelName(roomId: string): string {
  return `chat:${roomId}`;
}

export function userChannelName(userId: string): string {
  return `user:${userId}`;
}
